// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__QVKpx","left":"styles_left__1TlOT"};